import BaseNotification from '../BaseNotification'

export default class BookingCancelled extends BaseNotification {
  get iconClass(): string {
    return 'sc-icon-calendar-expire'
  }
}
